<template>
  <LayoutDivasChadsMinimal>
    <div id="sing-up">
      <section class="main">
        <div class="container">
          <div
            class="form loadable failable"
            :class="{ loading: newUserData.loading, failed: newUserData.error }"
          >
            <h1 class="title">
              {{ $t("register.title") }}
            </h1>
            <template
              v-if="
                newUserData.loading || newUserData.error || newUserData.data
              "
            >
              <RegisterForm
                :autologin="true"
                @successfullRegister="successfullRegisterHandler"
                @failedRegister="failedRegisterHandler"
              />
            </template>

            <template
              v-if="
                !newUserData.loading && !newUserData.error && !newUserData.data
              "
            >
              <p>
                {{ $t("finish_registration.invalid_token.error") }}
              </p>
              <button
                type="button"
                class="btn login"
                @click.prevent="goToLogin"
              >
                {{ $t("finish_registration.invalid_token.go_to_login") }}
              </button>
            </template>

            <div class="loader-wrapper">
              <Spinner />
            </div>

            <div class="failed-wrapper">
              <p>{{ $t("error") }}</p>
            </div>
          </div>
        </div>
      </section>
    </div>
    <template slot="after">
      <Footer />
    </template>
  </LayoutDivasChadsMinimal>
</template>

<script>
import Spinner from "../../components/Spinner";
import Footer from "../../components/Footer";
import LayoutDivasChadsMinimal from "../../layouts/LayoutDivasChadsMinimal";
import RegisterForm from "../../components/RegisterForm";
import PaymentStatus from "../../components/PaymentStatus";
import ThemeManager from "../../modules/ThemeManager/ThemeManager.js";

import resources from "../../resources";

export default {
  components: {
    PaymentStatus,
    RegisterForm,
    LayoutDivasChadsMinimal,
    Spinner,
    Footer,
  },
  data() {
    return {
      token: "",
      newUserData: {
        data: {
          email: null,
          finish_token: null,
        },
        loading: false,
        error: false,
      },
    };
  },
  methods: {
    successfullRegisterHandler() {
      if (this.$auth.user().membership_active) {
        this.$router.replace({ name: "home" });
      } else {
        this.$router.replace({ name: "dashboard" });
      }
    },
    failedRegisterHandler(resp) {
      //this.$router.replace({name: 'login'});
    },
    goToLogin() {
      this.$router.push({ name: "login" });
    },
  },
  mounted() {
    this.token = this.$route.query.token;

    // this.$refs.webstarRegisterMessage.innerHTML = this.$t(
    //   "register.webstar.message"
    // );
  }
};
</script>

<style scoped lang="scss">
@import "../../styles/variables";
@import "../../styles/classes";

#sing-up {
  background-color: var(--pallete_dark_color);
  display: flex;
  color: var(--pallete_clear_text_color);
  flex-direction: column;
  justify-content: center;
  max-width: 800px;

  .highlight-payment-box {
    margin: 1em;
  }

  .btn.login {
    @extend %fresh-btn;
    display: block;
    width: 100%;
    padding: 1em;
  }

  section.main {
    justify-content: space-around;
    position: relative;
    margin: 0;

    .container {
      display: flex;
      margin: 0 auto;
      padding: 1.5em;
      background-color: var(--background_01);
      border-radius: 10px;
      margin-left: 1em;
      margin-right: 1em;

      @media (max-width: 768px) {
        flex-direction: column;
      }

      @media (max-width: 450px) {
        border-radius: 0;
        margin-left: 0;
        margin-right: 0;
        padding: 0.5em;
        width: 100vw;
      }

      .form {
        display: block;
        // padding: 1em;
        padding-block: 1em;
        margin-left: 1em;
        border-radius: 5px;
        width: 100%;

        .title {
          text-align: center;
          width: 100%;
          text-transform: uppercase;
          letter-spacing: 0;
          margin: 0 0 0.5em 0;
        }

        @media (max-width: 500px) {
          min-width: auto;
        }

        @media (max-width: 768px) {
          margin-left: 0;
        }
      }
    }
  }

  .failed-wrapper {
    text-align: center;
    font-weight: bolder;
    padding-top: 1em;
  }
}

.change-mode {
  border-right: 5px solid var(--pallete_main_color);
  border-radius: 7px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;

  //cursor: pointer;
  user-select: none;
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  // flex-basis: 50%;
  color: #ffffff;
  text-align: center;

  width: 100%;
  // padding: 2.5em 1em;
  margin-bottom: 0;

  .abstract-content {
    position: absolute;
    bottom: 12%;

    @media (max-width: 768px) {
      bottom: 9.5%;

      .get-access-here {
        font-size: 6vw;
      }
    }

    @media (max-width: 425px) {
      bottom: 10.5%;

      .get-access-here {
        font-size: 6vw;
      }
    }

    @media (max-width: 375px) {
      bottom: 10%;
    }

  }

  img {
    width: 100%;
    height: 100%;
    object-fit: fill;
  }

  .title {
    text-transform: uppercase;
    font-size: 2em;

    margin-top: 0;
    margin-bottom: 2em;
    padding-inline: 1em;
  }

  .subtitle {
    text-transform: uppercase;
  }

  .get-access-here {
    @extend %fresh-btn;

    margin: 0;
    width: auto;
    display: inline-block;
    padding: 1em 1em;
    text-transform: uppercase;
    font-size: 1em;
    letter-spacing: 2px;
  }

  .footer {
    text-transform: uppercase;
    font-size: 0.9em;
    font-weight: bold;
    margin-top: 30px;
    text-shadow: 1px 1px #000;
  }
}

</style>
